<template>
    <div class="situation-Global">
        <header class="SG-header">
            <el-button @click="show = !show">展开</el-button>
            <div class="SG-button-group">

                <div v-show="show" class="transition-box">


                        <el-row class="SG-button-row">
                            <el-button size="mini" type="primary" @click="changeComponent('situationGlobalIndex')">聚合显示</el-button>
                            <el-button size="mini"  type="primary" @click="changeComponent('allProduct')">全部产品</el-button>
                            <el-button size="mini"  type="success" @click="changeComponent('finishedProduct')">已完成的产品</el-button>
                            <el-button size="mini"  type="info" @click="changeComponent('unstartedProduct')">未开始的产品</el-button>
                            <el-button size="mini"  type="primary" @click="changeComponent('developingProduct')">进行中的产品</el-button>
                            <el-button size="mini"  type="primary"
                                @click="changeComponent('overHalfTimeProduct')">消耗时间超过一半的产品</el-button>
                            <el-button size="mini"  type="primary"
                                @click="changeComponent('belowHalfTimeProduct')">消耗时间未超过一半的产品</el-button>
                            <el-button size="mini"  type="warning"
                                @click="changeComponent('belowHalfProgressProduct')">进度未超过一半的产品</el-button>
                            <el-button size="mini"  type="danger"
                                @click="changeComponent('overHalfProgressProduct')">进度超过一半的产品</el-button>
                        </el-row>

                </div>





            </div>
        </header>


        <!-- 动态切换组件区 -->
        <component :is=currentComponentName></component>



        <!-- 内容区域
        <div class="SG-content">

            <div class="SG-data-show">
                <h1 class="SG-data-title">聚簇显示</h1>


                <div class="SG-data">


                    <div class="data-left">
                        <span>全部产品有: {{situationGlobalData.allProjectCnt}}个</span>
                        <span>已完成的产品有: {{situationGlobalData.finishedProjectCnt}}个</span>
                        <span>未开始的产品有: {{situationGlobalData.unstartedProjectCnt}}个</span>
                        <span>进行中的产品有: {{situationGlobalData.developingProjectCnt}}个</span>
                    </div>

                    <div class="data-right">
                        <span>消耗时间超过一半产品有: {{situationGlobalData.overHalfTimeProjectCnt}}个</span>
                        <span>消耗时间未超过一半产品有: {{situationGlobalData.belowHalfTimeProjectCnt}}个</span>
                        <span>进度未超过一半产品有: {{situationGlobalData.belowHalfProgressProjectCnt}}个</span>
                        <span>进度超过一半的产品有: {{situationGlobalData.overHalfProgressProjectCnt}}个</span>
                    </div>
                </div>



            </div>

            <!-- 统计条状图 -->
        <!-- <div id="mychart" class="myChartStyle"></div>

        </div> -->




    </div>
</template>

<script>
// 引入 ECharts
import * as echarts from 'echarts';
// 引入 axios
import axios from 'axios';
// 引入 uri
import uri from '@/util/constant';

// 引入其他组件
import allProduct from '../situationGlobal/components/allProduct.vue';                      //  所有产品
import situationGlobalIndex from '../situationGlobal/components/situationGlobalIndex.vue';  //  聚合显示首页内容
import finishedProduct from './components/finishedProduct.vue';                             //  已完成的产品
import unstartedProduct from './components/unstartedProduct.vue';                           //  未开始的产品
import developingProduct from './components/developingProduct.vue';                         //  进行中的产品
import overHalfTimeProduct from './components/overHalfTimeProduct.vue';                     //  消耗时间超过一半的产品
import belowHalfTimeProduct from './components/belowHalfTimeProduct.vue';                   //  消耗时间未超过一半的产品
import belowHalfProgressProduct from './components/belowHalfProgressProduct.vue';           //  进度未超过一半的产品
import overHalfProgressProduct from './components/overHalfProgressProduct.vue';             //  进度超过一半的产品






export default {
    data() {
        return {
            // yData: ["名医直通车", "系统1", "系统2", "系统3", "系统4", "系统5", "系统6"],  //  条状图纵坐标轴
            // xData: [23, 24, 18, 25, 27, 28, 100],  //  条状图横坐标轴

            yData: [],                  //  纵坐标
            xData: [],                  //  横坐标
            myChart: null,              //  存储图表实例
            situationGlobalData: [],    //  頭部展示數組  
            situationGlobalCharts: [],  //  图表所需样例

            //  动态组件需用通过name属性来切换,以下是当前动态组件和它的名字
            currentComponentName: 'situationGlobalIndex',


            show: false

        };
    },
    components: {
        allProduct,                     //  全部产品的组件
        situationGlobalIndex,           //  聚合展示主页组件
        finishedProduct,                //  已完成的产品组件
        unstartedProduct,               //  未开始的产品组件
        developingProduct,              //  进行中的产品组件
        overHalfTimeProduct,            //  消耗时间超过一半的产品
        belowHalfTimeProduct,           //  消耗时间未超过一半的产品
        belowHalfProgressProduct,        //  进度未超过一半的产品
        overHalfProgressProduct
    },
    mounted() {
        //  渲染完成

    },
    beforeDestroy() {
        //  销毁之前
    },

    created() {
        //  创建后
    },

    // 方法区
    methods: {


        //  按钮切换组件
        changeComponent(name) {

            this.currentComponentName = name;   //  动态组件切换切换

        }

    }




};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
}

.situation-Global {
    width: 100%;
    min-height: 800px;


    /* background-color: #a8d8ea; */

    display: flex;
    flex-direction: column;
}




.SG-header {

    display: flex;
    flex-direction: column;
    gap: 15px;
    /* width: 1000px; */
    width: 100%;
    /* margin: 0 auto; */
    margin-bottom: 20px;
}

.SG-button-group {

    display: flex;
    flex-direction: column;
    gap: 15px;
    max-width: 1000px;
    justify-content: space-between;
}

.SG-button-row {
    margin-top: 20px;
    display: flex;
    gap: 50px;
    justify-content: flex-start;
}

.el-button {
    min-width: 180px;
    min-height: 30px;
}


.SG-content {

    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    width: 1200px;
}

.SG-data-show {

    display: flex;
    flex-direction: column;
    margin-top: 20px;
    width: 1000px;
    height: 197px;
    background-color: #f5f7fa;
    border-radius: 50px;
    align-items: center;
    margin: 0 auto;
    justify-content: center;
}

.SG-data-title {
    color: rgb(0, 47, 167);
}

.SG-data {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}

.data-left {
    display: flex;
    flex-direction: column;
    min-height: 100px;
    justify-content: space-around;
}


.data-right {
    display: flex;
    flex-direction: column;
    min-height: 100px;
    justify-content: space-around;
}

#mychart {
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background: white;
    width: 1000px;
    min-height: 400px;

}



.transition-box {

    display: flex;
    flex-direction: column;

    width: 100%;
    height: 100px;
  }
</style>